import { motion } from "framer-motion";
import { Timer, Link2, ListMusic } from "lucide-react";

const steps = [
  { icon: Timer, title: "Listen to the First Minute", text: "Every R-AN production streams its opening 60 seconds right here — no account, no paywall. Judge the track by its first minute, the way a DJ would." },
  { icon: Link2, title: "Follow the Links", text: "Hooked? Each release links straight to Spotify, Apple Music, YouTube, SoundCloud and Beatport so you can stream or buy the full version anywhere." },
  { icon: ListMusic, title: "Play the Full Catalogue", text: "Our official playlists collect the entire R-AN production on every major platform — one tap and the whole label is in your library." },
];

export const PreviewSpotlight = () => (
  <section id="preview" className="relative py-28 border-t border-white/10 overflow-hidden">
    <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-[#ff0055]/5 blur-[130px] rounded-full pointer-events-none" />
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="max-w-2xl mb-16">
        <p className="font-mono-tech text-xs tracking-[0.35em] text-[#ff0055] uppercase mb-3">// The 60-Second Rule</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold uppercase text-white">
          One Minute Is All <span className="text-transparent" style={{ WebkitTextStroke: "1.5px #00f0ff" }}>You Need</span>
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {steps.map((s, i) => (
          <motion.div
            key={s.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.12 }}
            className="bg-[#0c0c12] p-8 hover:bg-[#101018] transition-colors"
          >
            <div className="flex items-center justify-between mb-6">
              <s.icon size={26} className="text-[#00f0ff]" strokeWidth={1.5} />
              <span className="font-mono-tech text-xs text-slate-600">0{i + 1}</span>
            </div>
            <h3 className="font-display text-base font-bold text-white uppercase mb-3">{s.title}</h3>
            <p className="text-sm text-slate-400 leading-relaxed">{s.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
